import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DevicesReportsRoutingModule } from './devices-reports-routing.module';
import { DevicesReportsComponent } from './devices-reports.component';
import { ReportSharedModule } from '../reports/shared/report-shared.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [DevicesReportsComponent],
  imports: [
    CommonModule,
    SharedModule,
    ReportSharedModule,
    DevicesReportsRoutingModule,
  ],
})
export class DevicesReportsModule {}
